import React, { Component } from "react";
import { Typography, Link } from '@material-ui/core';

class Copyright extends Component {

    render() {
        return <Typography variant="body2" color="textSecondary" align="center">
                    {'Copyright © '}
                    <Link color="inherit" href="https://www.dataa.com.br">
                        <img src='https://www.dataa.com.br/wp-content/uploads/2021/03/Data-A-Soluc%CC%A7o%CC%83es-150x62.png'  alt="Logo Data A"/>
                    </Link>{' '}{new Date().getFullYear()}{'.'}
                </Typography>
        
    }
}


export default Copyright;